module.exports = __webpack_public_path__ + "media/images/flags/32/Somaliland-f6a76d14040dc700da6e4f0e28ae94de.png";